import { createSlice, PayloadAction } from '@reduxjs/toolkit';

interface AuthState {
  token: string | null;
  user: any | null;
  userType: 'admin' | 'doctor' | null;
  permissions: string[];
}

const initialState: AuthState = {
  token: localStorage.getItem('token') || null,
  user: JSON.parse(localStorage.getItem('user') || 'null'),
  userType: localStorage.getItem('userType') as 'admin' | 'doctor' | null,
  permissions: JSON.parse(localStorage.getItem('permissions') || '[]'),
};

const authSlice = createSlice({
  name: 'auth',
  initialState,
  reducers: {
    setCredentials: (
      state,
      action: PayloadAction<{
        token: string;
        user: any;
        userType: 'admin' | 'doctor';
        permissions?: string[];
      }>
    ) => {
      state.token = action.payload.token;
      state.user = action.payload.user;
      state.userType = action.payload.userType;
      state.permissions = action.payload.permissions ?? [];
      localStorage.setItem('token', action.payload.token);
      localStorage.setItem('user', JSON.stringify(action.payload.user));
      localStorage.setItem('userType', action.payload.userType);
      localStorage.setItem('permissions', JSON.stringify(state.permissions));
    },
    setPermissions: (state, action: PayloadAction<string[]>) => {
      state.permissions = action.payload;
      localStorage.setItem('permissions', JSON.stringify(action.payload));
    },
    logout: (state) => {
      state.token = null;
      state.user = null;
      state.userType = null;
      state.permissions = [];
      localStorage.removeItem('token');
      localStorage.removeItem('user');
      localStorage.removeItem('userType');
      localStorage.removeItem('permissions');
    },
  },
});

export const { setCredentials, setPermissions, logout } = authSlice.actions;
export default authSlice.reducer;
